import React from 'react'
import { Conditions } from './components/Conditions'
import styled from 'styled-components'
import { BridalPlanProps } from '../../BridalPlan.types'
import { Contents } from './components/Contents'
import { Price } from './components/Price'
import { styleTheme } from '../../../../style/theme'
import { getPrimaryColor } from '../../../../style/utils'

type MainProps = {
  className?: string
  plan: BridalPlanProps | undefined
  primaryColor?: string
}

export const Main = (props: MainProps) => {
  return <StyledComponent {...props} />
}

const Component = (props: MainProps) => (
  <div className={props.className}>
    <Price plan={props.plan} primaryColor={props.primaryColor} />
    <pre>{props.plan?.descriptionText}</pre>
    <Conditions plan={props.plan} primaryColor={props.primaryColor} />
    <Contents plan={props.plan} primaryColor={props.primaryColor} />
  </div>
)

const StyledComponent = styled(Component)`
  max-width: 960px;
  margin: 30px auto;
  padding: 0 2%;

  > .main-wrapper {
  }

  > .event-info-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-top: 36px;
    margin-left: 0;
    margin-bottom: 24px;
    @media (max-width: 520px) {
      margin-left: 0;
    }

    > .event-tag {
      background-color: ${styleTheme.colors.gray.light};
      padding: 4px 12px;
      border-radius: 4px;
      font-size: 14px;
      line-height: 21px;
      font-weight: 400;
      gap: 16px;
    }
  }

  h2 {
    font-family: 'Noto Sans JP', sans-serif;
    font-size: 18px;
    font-weight: bold;
    line-height: 27px;
    padding: 20px 0 0 0;
    color: ${getPrimaryColor};
    margin: 0 20px 20px 0;
  }

  > pre {
    color: ${styleTheme.colors.black};
    font-size: 14px;
    font-weight: 400;
    margin-top: 18px;
    margin-left: 0;
    line-height: 16px;
    margin-bottom: 60px;
    @media (max-width: 520px) {
      margin-left: 0;
    }
  }
`
